var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    d: "M7 0C3.111 0 0 3.111 0 7s3.111 7 7 7 7-3.111 7-7-3.176-7-7-7zm0 12.963c-3.306 0-5.963-2.657-5.963-5.963S3.694 1.037 7 1.037 12.963 3.63 12.963 7 10.306 12.963 7 12.963z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    d: "M7.749 3.386c-.586-.195-1.237-.195-1.889.13-.586.26-.976.782-1.237 1.368-.065.26.065.52.326.65.26.066.52-.064.586-.325.13-.39.39-.65.716-.846.326-.196.782-.196 1.107-.065.586.195.977.781.977 1.367 0 .912-1.628 1.498-1.628 1.498-.195.13-.326.39-.195.65.065.196.26.326.455.326h.13c.066 0 2.28-.78 2.28-2.409 0-1.042-.651-2.018-1.628-2.344zM7.033 9.768c-.26 0-.521.195-.521.52 0 .326.195.521.52.521.326 0 .521-.195.521-.52 0-.326-.26-.521-.52-.521z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.e2c384823ff1ba747c48591b5a8df0bc.svg";
export { ForwardRef as ReactComponent };